import React, { useEffect, useState, useRef } from 'react';
import './FeaturesListAdd.css';
// import './FeaturesListEdit.css';

const FeaturesListEdit = ({
  title = 'Plan Features',
  defaultSelectedOptions = [],
  allFeatures = [],
  onChange,
  validators = [],
  error = '',
  isRequired = false,
}) => {
  const [selectedValues, setSelectedValues] = useState(defaultSelectedOptions);
  const [errors, setErrors] = useState([]);
  const [hasInteracted, setHasInteracted] = useState(false);
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  useEffect(() => {
    if (Array.isArray(defaultSelectedOptions) && defaultSelectedOptions.length > 0) {
      setSelectedValues(prev => {
        if (prev.length === defaultSelectedOptions.length && prev.every((v, i) => v === defaultSelectedOptions[i])) {
          return prev;
        }
        return defaultSelectedOptions;
      });
    }
  }, [defaultSelectedOptions]);

  useEffect(() => {
    if (hasInteracted && validators?.length > 0) {
      const validationResults = validators
        .map((validator) => validator(selectedValues))
        .filter((result) => result !== true);

      setErrors(prev => {
        if (validationResults.length === 0 && prev.length === 0) return prev;
        return validationResults;
      });
    } else {
      setErrors(prev => (prev.length === 0 ? prev : []));
    }
  }, [selectedValues, validators, hasInteracted]);

  const handleRemove = (value) => {
    const updated = selectedValues.filter(v => v !== value);
    setHasInteracted(true);
    setSelectedValues(updated);
    onChange?.(updated);
  };

  const handleAdd = (value) => {
    const updated = [...selectedValues, value];
    setHasInteracted(true);
    setSelectedValues(updated);
    onChange?.(updated);
  };

  // ── Drag-and-drop reorder ──
  const handleDragStart = (index) => {
    dragItem.current = index;
  };

  const handleDragEnter = (index) => {
    dragOverItem.current = index;
  };

  const handleDragEnd = () => {
    const updated = [...selectedValues];
    const dragged = updated.splice(dragItem.current, 1)[0];
    updated.splice(dragOverItem.current, 0, dragged);
    dragItem.current = null;
    dragOverItem.current = null;
    setSelectedValues(updated);
    onChange?.(updated);
  };

  const selectedFeatures = selectedValues
    .map(val => allFeatures.find(f => f.value === val))
    .filter(Boolean);

  const unselectedFeatures = allFeatures.filter(f => !selectedValues.includes(f.value));

  const displayErrors = error ? [error] : errors;

  const handleSelectAllUnselected = () => {
    const allUnselectedValues = unselectedFeatures.map(f => f.value);

    const updated = [...new Set([...selectedValues, ...allUnselectedValues])];

    setSelectedValues(updated);
    onChange?.(updated);
  };

  return (
    <div className='fle-wrapper'>

      {/* ── Plan Features (selected) section ── */}
      <div className='fle-section'>
        <div className='fle-section-header'>
          {/* <input className='' type="checkbox" readOnly /> */}
          <div className='selectbox-header-feat'>
            <p className='table-selectbox-span-heading'>{title}{isRequired && <span className="required-star">*</span>}</p>
            <p className='fle-subtitle'>You can drag and drop to rearrange the features and set their display order</p>
          </div>
        </div>

        <div className='fle-list'>
          {selectedFeatures.map((option, index) => (
            <div
              key={option.value}
              className='fle-item fle-item-selected'
              draggable
              onDragStart={() => handleDragStart(index)}
              onDragEnter={() => handleDragEnter(index)}
              onDragEnd={handleDragEnd}
              onDragOver={(e) => e.preventDefault()}
            >
              <input
                className='table-selectbox'
                type="checkbox"
                checked
                readOnly
              />
              <span className='table-selectbox-span fle-item-label'>{option.label}</span>
              <button
                className='fle-action-btn fle-remove-btn'
                onClick={() => handleRemove(option.value)}
                title="Remove"
              >
                −
              </button>
            </div>
          ))}
          {selectedFeatures.length === 0 && (
            <p className='fle-empty'>No features selected yet.</p>
          )}
        </div>
      </div>

      {/* ── Add New (unselected) section ── */}
      {unselectedFeatures.length > 0 && (
        <div className='fle-section fle-section-add'>
          <div className='fle-section-header'>
            <input
              className='table-selectbox'
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) handleSelectAllUnselected();
              }}
            />
            <p className='fle-section-title'>Add New</p>
          </div>

          <div className='fle-list'>
            {unselectedFeatures.map((option) => (
              <div key={option.value} className='fle-item fle-item-unselected'>
                <input
                  className='table-selectbox'
                  type="checkbox"
                  disabled
                />
                <span className='table-selectbox-span fle-item-label fle-label-muted'>{option.label}</span>
                <button
                  className='fle-action-btn fle-add-btn'
                  onClick={() => handleAdd(option.value)}
                  title="Add"
                >
                  +
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {displayErrors.length > 0 && (
        <div className="input-error-message fts-12 fetaure-list-error">
          {displayErrors}
        </div>
      )}
    </div>
  );
};

export default FeaturesListEdit;